import { Field, FieldProps, FormikProps } from 'formik';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import { CompanyOrigin } from '../../../../dataStore';
import { originEnumToString } from '../../company';
import { ContentWrapper } from './contentWrapper';
import { TabFields } from './tabFields';
import { useStyles } from './tabs.jss';

export interface CompanyInfoTabProps {
  number: string;
  name: string;
  origin: number;
  externalId: string;
  handleChange(e: React.ChangeEvent): void;
  key: string;
  parentName: string;
}

export const CompanyInfoFields = (props: CompanyInfoTabProps) => {
  const [t] = useTranslation();
  const classes = useStyles();

  const originOnChangeWrapper = useCallback(
    (form: FormikProps<any>) => {
      return (
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>
      ) => {
        props.handleChange(event as React.ChangeEvent<any>);
        form.setFieldValue('company.origin', event.target.value);
      };
    },
    [props.handleChange]
  );

  return (
    <ContentWrapper>
      <TabFields
        handleChange={props.handleChange}
        fields={{
          number: props.number,
          name: props.name,
          externalId: props.externalId,
        }}
        key={props.key}
        parentName={props.parentName}
      />
      <Field
        name="origin"
        render={({ field, form }: FieldProps) => (
          <FormControl className={classes.selectMargin}>
            <InputLabel>
              {t<string>('newnity.company.origin')}
            </InputLabel>
            <Select value={props.origin} variant="standard" onChange={originOnChangeWrapper(form)}>
              <MenuItem value={0}>&nbsp;</MenuItem>
              <MenuItem value={CompanyOrigin.Harmony}>
                {originEnumToString(CompanyOrigin.Harmony)}
              </MenuItem>
              <MenuItem value={CompanyOrigin.MagentoSmbUsa}>
                {originEnumToString(CompanyOrigin.MagentoSmbUsa)}
              </MenuItem>
            </Select>
          </FormControl>
        )}
      />
    </ContentWrapper>
  );
};
